import { useEffect } from 'react'

const BASE_URL = 'https://terra-planner.com'
const DEFAULT_OG_IMAGE = `${BASE_URL}/og-image.png`

export const PageSeo = ({ title, description, path, schema, noIndex = false, ogImage }) => {
  const fullTitle = `${title} · TerraPlanner`
  const canonical = `${BASE_URL}${path}`
  const ogImg = ogImage || DEFAULT_OG_IMAGE

  useEffect(() => {
    if (!schema) return
    const el = document.createElement('script')
    el.type = 'application/ld+json'
    el.textContent = JSON.stringify(schema)
    document.head.appendChild(el)
    return () => document.head.removeChild(el)
  }, [schema])

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noIndex ? 'noindex, nofollow' : 'index, follow'} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImg} />
      <meta property="og:site_name" content="TerraPlanner" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImg} />
    </>
  )
}
